const CHUNK_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /Loading chunk [\w-]+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /dynamically imported module/i,
];

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const message = `${error.name || ''} ${error.message || ''}`;
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};
